export default "__VITE_ASSET__85ba2a84__"